import request from "@/utils/request"

// 查询订单管理列表
export function orderList(params) {
  return request({
    url: "/server/order/list",
    method: "get",
    params: params,
  })
}
// 查询订单管理列表(仅管理员端-主要自动下载用)
export function orderListPost(params) {
  return request({
    url: `/server/order/listPost?pageSize=${params.pageSize}&pageNum=${params.pageNum}`,
    method: "post",
    data: params,
  })
}

// 订单支付
export function orderPay(data) {
  return request({
    url: "/server/order/pay",
    method: "post",
    data: data,
  })
}
// 预约码订单关联
export function needQrCodeOrder(data) {
  return request({
    url: "/server/order/needQrCodeOrder",
    method: "post",
    data: data,
  })
}
// 查询待支付订单详情
export function listPay(params) {
  return request({
    url: "/server/order/listPay",
    method: "get",
    params: params,
  })
}

// 获取订单详情
export function getOrderDetail(appId) {
  return request({
    url: `/server/order/getInfo/${appId}`,
    method: "get",
  })
}

// 修改订单收货信息
export function editAddr(data) {
  return request({
    url: "/server/order/editAddr",
    method: "post",
    data: data,
  })
}

// 同步订单
export function syncOrder(params) {
  return request({
    url: "/server/order/sync",
    method: "get",
    params: params,
  })
}

// 修改产品订单sku
export function editSku(data) {
  return request({
    url: "/server/order/editSku",
    method: "post",
    data: data,
  })
}

// 拆分产品订单sku
export function splitSku(data) {
  return request({
    url: "/server/order/splitSku",
    method: "post",
    data: data,
  })
}

// 关联产品 订单sku
export function matchSku(data) {
  return request({
    url: "/server/order/matchSku",
    method: "post",
    data: data,
  })
}

// 批量关联产品 订单sku
export function matchSkuPics(data) {
  return request({
    url: "/server/order/matchSkuPics",
    method: "post",
    data: data,
  })
}

// 批量检测关联产品 订单sku
export function checkMatchSkuPics(data) {
  return request({
    url: "/server/order/checkMatchSkuPics",
    method: "post",
    data: data,
  })
}

// 修改订单销售金额
export function editSale(data) {
  return request({
    url: "/server/order/editSale",
    method: "post",
    data: data,
  })
}

// 查询手续费列表
export function listPlatFee() {
  return request({
    url: "/server/order/listPlatFee",
    method: "get",
  })
}

// 手续费率保存
export function addPlatFee(data) {
  return request({
    url: "/server/order/addPlatFee",
    method: "post",
    data: data,
  })
}

// 查询汇率列表
export function listCurrencyFee() {
  return request({
    url: "/server/order/listCurrencyFee",
    method: "get",
  })
}

// 汇率保存
export function addCurrencyFee(data) {
  return request({
    url: "/server/order/addCurrencyFee",
    method: "post",
    data: data,
  })
}

// 订单复制
export function orderCopy(data) {
  return request({
    url: "/server/order/copy",
    method: "post",
    data: data,
  })
}

// 订单取消
export function cancelOrder(data) {
  return request({
    url: "/server/order/cancel",
    method: "post",
    data: data,
  })
}

// 订单恢复
export function recoveryOrder(data) {
  return request({
    url: "/server/order/recovery",
    method: "post",
    data: data,
  })
}

// 查询已关联产品列表
export function listLink(params) {
  return request({
    url: "/server/order/listLink",
    method: "get",
    params: params,
  })
}

// 删除已关联产品（表id）
export function deleteLink(ids) {
  return request({
    url: `/server/order/deleteLink/${ids}`,
    method: "post",
  })
}
// 删除已关联产品（skuID）
export function deleteLinkBySku(ids) {
  return request({
    url: `/server/order/deleteLinkBySku/${ids}`,
    method: "post",
  })
}

// 查询已转换产品列表
export function listChange(params) {
  return request({
    url: "/server/order/listChange",
    method: "get",
    params: params,
  })
}

// 删除已转换产品(表id)
export function deleteChange(ids) {
  return request({
    url: `/server/order/deleteChange/${ids}`,
    method: "post",
  })
}
// 删除已转换产品(skuId)
export function deleteChangeBySku(ids) {
  return request({
    url: `/server/order/deleteChangeBySku/${ids}`,
    method: "post",
  })
}

// 查询导入列表
export function listImport(params) {
  return request({
    url: "/server/order/listImport",
    method: "get",
    params: params,
  })
}

// 订单导入
export function uploadUniversalOrder(data) {
  return request({
    url: "/server/order/uploadUniversal",
    method: "post",
    data: data,
  })
}

// 订单导入
export function uploadLazada(data) {
  return request({
    url: "/server/order/uploadLazada",
    method: "post",
    data: data,
  })
}

// 订单导入
export function uploadOrder(data) {
  return request({
    url: "/server/order/upload",
    method: "post",
    data: data,
  })
}

// 订单导入
export function uploadTb(data) {
  return request({
    url: "/server/order/uploadTb",
    method: "post",
    data: data,
  })
}

// 获取亚马逊订单导入详细信息
export function getImportInfo(importId) {
  return request({
    url: `/server/order/getImportInfo/${importId}`,
    method: "get",
  })
}

// 复制订单详情
export function orderToCopy(appId) {
  return request({
    url: `/server/order/toCopy/${appId}`,
    method: "get",
  })
}

// 转换产品 订单sku
export function changeSku(data) {
  return request({
    url: "/server/order/changeSku",
    method: "post",
    data: data,
  })
}

// 删除产品 订单sku
export function deleteSku(appSkuId) {
  return request({
    url: "/server/order/deleteSku/" + appSkuId,
    method: "POST",
  })
}

// 查询FBA订单管理列表
export function listFba(params) {
  return request({
    url: "/server/order/listFba",
    method: "get",
    params: params,
  })
}

// 获取FBA订单详细信息
export function getFbaInfo(appId) {
  return request({
    url: `/server/order/getFbaOr1688Info/${appId}`,
    method: "get",
  })
}

// 订单审核
export function auditSale(data) {
  return request({
    url: "/server/order/audit",
    method: "post",
    data: data,
  })
}

export function loadAllAppIds(form) {
  let shopId =
    form.account == "all"
      ? null
      : form.account == "manual"
      ? null
      : form.account
  let manualFlag = form.account == "all" ? null : form.manualFlag
  let eId = form.channel == "all" ? null : form.channel
  let status = form.status == "all" ? null : form.status
  let country = form.country == "all" ? null : form.country
  let params = {
    eId: eId,
    shopId: shopId,
    sOrderStatus: status,
    country: country,
    cons: form.cons,
    eAppNo: form.eAppNo,
    sAppNo: form.sAppNo,
    sortord: form.sortord,
    byAsc: form.byAsc,
    startLimit: form.startLimit,
    endLimit: form.endLimit,
    manualFlag: manualFlag,
  }
  return request({
    url: "/order/all/appIds",
    method: "get",
    params: params,
  })
}

export function saveOrder(params) {
  return request({
    url: "/order/create",
    method: "put",
    data: params,
  })
}

export function saveRemark(params) {
  return request({
    url: "/order/saveRemark",
    method: "put",
    params: params,
  })
}

export function updateOrderState(params) {
  return request({
    url: "/order/updateState",
    method: "put",
    params: params,
  })
}

export function getNoteList(appId) {
  return request({
    url: "/order/" + appId + "/all/note",
    method: "get",
  })
}

//根据订单号获取拣货说明
export function getOrderJHNote(appId) {
  return request({
    url: "/order/" + appId + "/jh/note",
    method: "get",
  })
}

export function deleteRemark(id) {
  return request({
    url: "/order/remark/" + id + "/delete",
    method: "delete",
  })
}
//将订单添加到黑名单
export function moveToBlack(id) {
  return request({
    url: "/order/" + id + "/moveToBlack",
    method: "put",
  })
}

export function exportExcel(params) {
  return request({
    url: "/order/export",
    method: "get",
    data: params,
  })
}
export function downloadFile(params) {
  return request({
    url: "common/download",
    method: "get",
    params: params,
  })
}

export function getSynAllOrders(params) {
  return request({
    url: "/order/getSynAllOrders",
    method: "get",
    params: params,
  })
}

export function updataExpre(params) {
  return request({
    url: "/order/updateExpre",
    method: "put",
    params: params,
  })
}
// 订单加急
export function createShip(data) {
  return request({
    url: "/server/order/ship/create",
    method: "post",
    data: data,
  })
}
// 订单批量加急（新）
export function createBatchShip(data) {
  return request({
    url: "/server/order/ship/createBatch",
    method: "post",
    data: data,
  })
}
// 结算页面查询支持的物流方式
export function getOrderShip(data) {
  return request({
    url: "/server/order/ship",
    method: "post",
    data: data,
  })
}
// 修改订单物流信息
export function editExpre(data) {
  return request({
    url: "/server/order/editExpre",
    method: "post",
    data: data,
  })
}

// 查询FBA订单管理列表
export function list1688(params) {
  return request({
    url: "/server/order/list1688",
    method: "get",
    params: params,
  })
}

// 查询FBA订单管理列表
export function sendUserCodeSms(params) {
  return request({
    url: "/server/order/sendUserCodeSms",
    method: "post",
    params: params,
  })
}
// 修改转换产品
export function editChange(data) {
  return request({
    url: "/server/order/editChange",
    method: "post",
    data: data,
  })
}

// 关联订单详情
export function editLink(data) {
  return request({
    url: `/server/order/editLink`,
    method: "post",
    data: data,
  })
}
// 关联订单详情
export function sendByHand(data) {
  return request({
    url: `/server/order/sendByHand`,
    method: "post",
    data: data,
  })
}
// 关联订单详情
export function sendPhByHand(data) {
  return request({
    url: `/server/order/sendPhByHand`,
    method: "post",
    data: data,
  })
}
// 物流追踪
export function getExpreProcess(data) {
  return request({
    url: `/sOrderExpreProcess/getExpreProcess`,
    method: "GET",
    params: data,
  })
}

//查询物流进度
export function selectExpreList(data) {
  return request({
    url: `/sOrderExpre/selectExpreList`,
    method: "GET",
    params: data,
  })
}

//查询物流进度
export function editOrder(data) {
  return request({
    url: `/server/order/edit`,
    method: "POST",
    data: data,
  })
}
//退款
export function forceCancel(data) {
  return request({
    url: `/server/order/forceCancel`,
    method: "POST",
    data: data,
  })
}
//退款
export function getDesignInfo(data) {
  return request({
    url: `/server/order/getDesignInfo?designId=` + data,
    method: "GET",
  })
}

// 获取最多可生成的商品编码数量
export function setOrderRemark(data) {
  return request({
    url: "/server/order/setOrderRemark",
    method: "post",
    data: data,
  })
}

// 获取最多可生成的商品编码数量
export function deleteOrderRemark(data) {
  return request({
    url: "/server/order/deleteOrderRemark/" + data,
    method: "post",
  })
}

// 获取最多可生成的商品编码数量
export function getTb(data) {
  return request({
    url: "/server/order/getTb",
    method: "get",
    params: data,
  })
}

// 订单导入
export function uploadShopee(data) {
  return request({
    url: "/server/order/uploadShopee",
    method: "post",
    data: data,
  })
}

// 订单导入
export function shippingParameter(data) {
  return request({
    url: "/server/order/shippingParameter",
    method: "GET",
    params: data,
  })
}
// 订单导入
export function shippingOrder(data) {
  return request({
    url: "/server/order/shippingOrder",
    method: "POST",
    data: data,
  })
}

// 获取最多可生成的商品编码数量
export function downloadDoc(data) {
  return request({
    url: "/server/order/downloadDoc",
    method: "get",
    params: data,
  })
}

export function handSetOrder(data) {
  return request({
    url: "/server/order/handSetOrder",
    method: "POST",
    data: data,
  })
}

export function batchPackOrder(data) {
  return request({
    url: "/server/order/batchPackOrder",
    method: "POST",
    data: data,
    params: data,
  })
}

export function batchGetOrderDoc(data) {
  return request({
    url: "/server/order/batchGetOrderDoc",
    method: "POST",
    data: data,
    params: data,
  })
}

export function batchShippingOrder(data) {
  return request({
    url: "/server/order/batchShippingOrder",
    method: "POST",
    data: data,
    params: data,
  })
}

export function batchDownloadDoc(data) {
  return request({
    url: "/server/order/BatchDownloadDoc",
    method: "GET",
    data: data,
    params: data,
  })
}

export function getOrderCnt(data) {
  return request({
    url: "/server/order/getOrderCnt",
    method: "GET",
    data: data,
    params: data,
  })
}
export function getOrderCntPost(data) {
  return request({
    url: "/server/order/getOrderCntV1",
    method: "post",
    data: data,
    // params: data,
  })
}

export function batchSendPhByHand(data) {
  return request({
    url: "/server/order/batchSendPhByHand",
    method: "POST",
    data: data,
  })
}

export function getOrderSellerCnt(data) {
  return request({
    url: "/server/order/getOrderSellerCnt",
    method: "GET",
    params: data,
    data: data
  })
}
export function getOrderSellerCntPost(data) {
  return request({
    url: "/server/order/getOrderSellerCntV1",
    method: "post",
    data: data
  })
}


export function batchGetTiktokDoc(data) {
  return request({
    url: "/server/order/batchGetTiktokDoc",
    method: "GET",
    data: data,
    params: data,
  })
}
export function batchShipPackage(data) {
  return request({
    url: "/server/order/batchShipPackage",
    method: "POST",
    data: data,
    params: data,
  })
}
export function listCntShopee(data) {
  return request({
    url: "/product/shopeeApi/listCnt",
    method: "GET",
    params: data,
  })
}
export function listCntTiktok(data) {
  return request({
    url: "/product/tiktokApi/listCnt",
    method: "GET",
    params: data,
  })
}
export function getCategories(data) {
  return request({
    url: "/product/tiktokApi/getCategories",
    method: "GET",
    params: data,
  })
}

export function uploadTiktok(data) {
  return request({
    url: "/server/order/uploadTiktok",
    method: "POST",
    data: data,
  })
}

export function moveProduct(data) {
  return request({
    url: "/server/product/moveProduct",
    method: "POST",
    data: data,
  })
}
// 刷新
export function freshByAppNo(data) {
  return request({
    url: '/server/order/freshByAppNo',
    method: 'get',
    params: data
  })
}
export function sendTemuShip(data) {
  // temu批量发货
  return request({
    url: "/server/order/sendTemuShip",
    method: "POST",
    data: data,
  })
}
export function setOrderFee(data) {
  // 补费
  return request({
    url: "/server/order/setOrderFee",
    method: "POST",
    data: data,
  })
}
export function setFactoryUser(data) {
  // 手动派单
  return request({
    url: "/server/order/setFactoryUser",
    method: "POST",
    data: data,
  })
}
// 自动派单
export function setFactoryUserAuto(params) {
  return request({
    url: "/server/order/setFactoryUserAuto",
    method: "GET",
    params,
  })
}
// 批量备注
export function setAdminRemark(params) {
  return request({
    url: '/server/order/setAdminRemark',
    method: 'get',
    params: params
  })
}
// 自动下载-启动任务（temu全托）
export function zipPicklistPdf(params) {
  return request({
    url: '/server/order/zipPicklistPdf',
    method: 'get',
    params: params
  })
}
// 自动下载-启动任务（temu全托-管理员端）
export function zipPicklistPdfPost(params) {
  return request({
    url: '/server/order/zipPicklistPdfV1',
    method: 'post',
    data: params
  })
}
// // 自动下载（半托）-启动任务（shein全托）(弃用)
// export function zipPicklistPdfForShein(params) {
//   return request({
//     url: '/server/order/zipPicklistPdfForShein',
//     method: 'get',
//     params: params
//   })
// }
// 自动下载（半托）-启动任务（temu半托）
export function zipPicklistPdfBt(params) {
  return request({
    url: '/server/order/zipPicklistPdfBt',
    method: 'get',
    params: params
  })
}
// 自动下载（半托）-启动任务（temu半托-管理员端）
export function zipPicklistPdfBtPost(params) {
  return request({
    url: '/server/order/zipPicklistPdfBtV1',
    method: 'post',
    data: params
  })
}
// // 自动下载（半托）-启动任务（shein半托）(弃用)
// export function zipPicklistPdfBtForShein(params) {
//   return request({
//     url: '/server/order/zipPicklistPdfBtForShein',
//     method: 'get',
//     params: params
//   })
// }
// // 自动下载（国内发货）-启动任务 -- 弃用
// export function zipPicklistPdfDomesticAuto(params) {
//   return request({
//     url: '/server/order/zipPicklistPdfDomesticAuto',
//     method: 'get',
//     params: params
//   })
// }

// 自动下载-任务列表（temu全托）
export function zipList(params) {
  return request({
    url: '/server/order/zipList',
    method: 'get',
    params: params
  })
}
// 自动下载-任务列表（半托）
export function zipListBt(params) {
  return request({
    url: '/server/order/zipListBt',
    method: 'get',
    params: params
  })
}
// 自动下载-新拣货单详情
export function orderReportList(params) {
  return request({
    url: '/server/report/list',
    method: 'get',
    params: params
  })
}
// 自动下载-新拣货单详情（temu半托）
export function orderReportListBt(params) {
  return request({
    url: '/server/report/listBt',
    method: 'get',
    params: params
  })
}
// 自动下载-新拣货单详情（shein半托）
export function orderSheinReportListBt(params) {
  return request({
    url: '/server/report/listBtForShein',
    method: 'get',
    params: params
  })
}
// 自动下载-拣货单设置接单工厂
export function orderReportEdit(data) {
  return request({
    url: '/server/report/edit',
    method: 'post',
    data: data
  })
}

// 自动下载-导出
export function orderReportExport(params) {
  return request({
    url: '/server/report/export',
    method: 'get',
    params: params
  })
}

// 自动下载-删除压缩包
export function delZip(data) {
  return request({
    url: '/server/order/delZip',
    method: 'post',
    data: data
  })
}

// 查询历史条件
export function getTimingData(data) {
  return request({
    url: '/server/order/getTimingData',
    method: 'get',
    params: data
  })
}
// 运营利润报表
export function getProfitList(data) {
  return request({
    url: '/server/profit/list',
    method: 'get',
    params: data
  })
}
// 运营利润报表-半托
export function getProfitListBt(data) {
  return request({
    url: '/server/profit/listBt',
    method: 'get',
    params: data
  })
}
// 每日运营利润报表
export function getProfitDayList(data) {
  return request({
    url: '/server/profit/dayList',
    method: 'get',
    params: data
  })
}
// 每日运营利润报表-半托
export function getProfitDayListBt(data) {
  return request({
    url: '/server/profit/dayListBt',
    method: 'get',
    params: data
  })
}
// 一键发货
export function setOrderAuto(data) {
  return request({
    url: '/server/order/setOrderAuto',
    method: 'post',
    data: data
  })
}
// 自动关联-关系列表
export function getMatchList(data) {
  return request({
    url: '/server/match/list',
    method: 'get',
    params: data
  })
}
// 自动关联-新增关系
export function matchAdd(data) {
  return request({
    url: '/server/match/add',
    method: 'post',
    data: data
  })
}
// 自动关联-去关联
export function matchSkuDz(data) {
  return request({
    url: '/server/order/matchSkuDz',
    method: 'post',
    data: data
  })
}
// 自动关联-删除
export function matchRemove(data) {
  return request({
    url: '/server/match/remove',
    method: 'post',
    data: data
  })
}
// 删除订单
export function deleteOrder(data) {
  return request({
    url: '/server/order/deleteOrder',
    method: 'post',
    data: data
  })
}
// 导出订单
export function downloadPicklistPdf(data) {
  return request({
    url: '/server/order/downloadPicklistPdf',
    method: 'get',
    params: data
  })
}
// 下载工厂图
export function downloadBoxpic(data) {
  return request({
    url: '/server/order/downloadBoxpic',
    method: 'get',
    params: data
  })
}
// 下载原图
export function downloadOriginalImage(data) {
  return request({
    url: '/server/order/downloadOriginalImage',
    method: 'get',
    params: data
  })
}
// 下载标签
export function downloadBoxlabel(data) {
  return request({
    url: '/server/order/downloadBoxlabel',
    method: 'get',
    params: data
  })
}
// 下载打印图
export function downloadPrintImage(data) {
  return request({
    url: '/server/order/downloadPrintImage',
    method: 'get',
    params: data
  })
}
// 下载拣货单-标记已下载
export function downloadZipFileNew(data) {
  return request({
    url: '/server/order/downloadZipFileNew',
    method: 'get',
    params: data
  })
}

// 新导出订单
export function downloadPicklistPdfNew(data) {
  return request({
    url: '/server/order/downloadPicklistPdfNew',
    method: 'get',
    params: data
  })
}
// 新导出订单（半托）
export function downloadPickListBtNew(data) {
  return request({
    url: '/server/order/downloadPickListBtNew',
    method: 'get',
    params: data
  })
}
// 下载打印图
export function downloadPrintImageNew(data) {
  return request({
    url: '/server/order/downloadPrintImageNew',
    method: 'get',
    params: data
  })
}
// 下载工厂图
export function downloadBoxpicNew(data) {
  return request({
    url: '/server/order/downloadBoxpicNew',
    method: 'get',
    params: data
  })
}
// 下载工厂图
export function downloadBoxpicNewBt(data) {
  return request({
    url: '/server/order/downloadBoxpicNewBt',
    method: 'get',
    params: data
  })
}
// 下载效果图
export function downloadXiaoGuoNew(data) {
  return request({
    url: '/server/order/downloadXiaoGuoNew',
    method: 'get',
    params: data
  })
}
// 下载原图
export function downloadOriginalImageNew(data) {
  return request({
    url: '/server/order/downloadOriginalImageNew',
    method: 'get',
    params: data
  })
}
// 下载中心-列表
export function reportList(data) {
  return request({
    url: '/server/report/file/list',
    method: 'get',
    params: data
  })
}
// 下载中心-标记已下载
export function markAsDownloaded(data) {
  return request({
    url: '/server/report/file/markAsDownloaded',
    method: 'get',
    params: data
  })
}
// // 下载中心-删除
export function reportFileDel(data) {
  return request({
      url: '/server/report/file/' + data,
      method: 'delete',
  })
}
// 自动下载-删除
export function reportRemove(data) {
  return request({
      url: '/server/report/remove',
      method: 'post',
      data: data
  })
}

// 预约送货信息
export function getOrderQrInfo(data) {
  return request({
    url: '/server/order/getOrderQrInfo',
    method: 'get',
    params: data
  })
}
// 自动生成
export function getOrderQrInfoAuto(data) {
  return request({
    url: '/server/order/getOrderQrInfoAuto',
    method: 'get',
    params: data
  })
}
//图片更新 
export function checkUpdatePic(data) {
  return request({
    url: '/server/order/checkUpdatePic',
    method: 'get',
    params: data
  })
}
//监听数据汇总
export function merchantOrderStatistics(data) {
  return request({
    url: '/server/order/merchantOrderStatistics',
    method: 'get',
    params: data
  })
}
// 商家下单数据
export function reportOrderList(data) {
  return request({
    url: '/server/reportOrder/list',
    method: 'get',
    params: data
  })
}
// 预约码列表
export function getDayQrList(data) {
  return request({
    url: '/server/day/qr/list',
    method: 'get',
    params: data
  })
}
// // 预约码-导出
// export function exportDayQr(data) {
//   return request({
//     url: '/server/day/qr/export',
//     method: 'get',
//     params: data
//   })
// }
// 预约码-修改
export function setDayQr(data) {
  return request({
    url: '/server/day/qr/set',
    method: 'post',
    data: data
  })
}
// 预约码-补充条码
export function setEmpty(data) {
  return request({
    url: '/server/day/qr/setEmpty',
    method: 'post',
    data: data
  })
}
// 订单报表统计
export function getrankOrderList(data) {
  return request({
    url: '/server/rankOrder/list',
    method: 'get',
    params: data
  })
}
// 订单报表统计
export function getrankOrderListTotal(data) {
  return request({
    url: '/server/rankOrder/listTotal',
    method: 'get',
    params: data
  })
}
// 获取物流面单
export function getYTwoDoc(data) {
  return request({
    url: '/server/order/getYTwoDoc',
    method: 'post',
    data: data
  })
}
// 全托广东出货
export function sendFactoryBySkuId(data) {
  return request({
    url: '/server/order/sendFactoryBySkuId',
    method: 'post',
    data: data
  })
}
// 获取图片的cm²
export function getPicSizeInfo(data) {
  return request({
    url: '/server/order/getPicSizeInfo',
    method: 'post',
    data: data
  })
}
// 质补原因提交
export function setRejectRemark(data) {
  return request({
    url: '/server/order/setRejectRemark',
    method: 'post',
    data: data
  })
}
// 发送短信
export function listSms(data) {
  return request({
    url: '/listSms',
    method: 'get',
    params: data
  })
}
// 发送短信
export function updateBatchVoiceFlag(data) {
  return request({
    url: '/server/order/updateBatchVoiceFlag',
    method: 'post',
    data: data
  })
}
// 退货申请
export function refundApply(data) {
  return request({
    url: '/server/order/refundApply',
    method: 'POST',
    data: data
  })
}
// 恢复订单
export function reSetRefundApply(data) {
  return request({
    url: '/server/order/reSetRefundApply',
    method: 'POST',
    data: data
  })
}
// 退货申请列表
export function refundApplyList(data) {
  return request({
    url: '/server/order/refundApplyList',
    method: 'get',
    params: data
  })
}
// 退货申请-审核
export function editRefundApply(data) {
  return request({
    url: '/server/order/editRefundApply',
    method: 'POST',
    data: data
  })
}
// 导入订单
export function importExcelOrders(data) {
  return request({
    url: '/server/order/importExcelOrders',
    method: 'POST',
    data: data
  })
}
// 导入订单(oss)
export function importExcelOrdersOss(data) {
  return request({
    url: '/server/order/importExcelOrdersOss',
    method: 'POST',
    data: data
  })
}
// 导入订单
export function uploadTiktokV1(data) {
  return request({
    url: '/server/order/uploadTiktokV1',
    method: 'POST',
    data: data
  })
}
// 导入运单号
export function uploadTrackNumberV1(data) {
  return request({
    url: '/server/order/uploadTrackNumberV1',
    method: 'POST',
    data: data
  })
}
// 导入亚马逊订单
export function uploadAmazonV1(data) {
  return request({
    url: '/server/order/uploadAmazonV1',
    method: 'POST',
    data: data
  })
}
// 导入沃尔玛订单
export function importWoErMaOrders(data) {
  return request({
    url: '/server/order/importWoErMaOrders',
    method: 'POST',
    data: data
  })
}
// 导入速卖通订单
export function importSuMaiTongOrders(data) {
  return request({
    url: '/server/order/importSuMaiTongOrders',
    method: 'POST',
    data: data
  })
}
// 导入eaby订单
export function importEbayOrder(data) {
  return request({
    url: '/server/order/importEbayOrder',
    method: 'POST',
    data: data
  })
}
// 导入美客多订单
export function importMercadoOrders(data) {
  return request({
    url: '/server/order/importMercadoOrders',
    method: 'POST',
    data: data
  })
}
// 拣货单监控数据
export function getZipReportJob(data) {
  return request({
    url: '/server/order/getZipReportJob',
    method: 'get',
    params: data
  })
}
// 批量补单
export function setSkuResend(data) {
  return request({
    url: '/server/order/setSkuResend',
    method: 'post',
    data: data
  })
}
// 撤销补单
export function coverSkuResend(data) {
  return request({
    url: '/server/order/coverSkuResend',
    method: 'post',
    data: data
  })
}
// 昨天资金核对情况
export function checkFundUserList(data) {
  return request({
    url: '/server/order/checkFundUserList',
    method: 'get',
    params: data
  })
}
// 导入图片匹配
export function uploadAboradPicInfoV1(data) {
  return request({
    url: '/server/order/uploadAboradPicInfoV1',
    method: 'post',
    data: data
  })
}
// 查询上传图
export function getOrderSkuPics(data) {
  return request({
    url: '/server/order/getOrderSkuPics/'+data.appSkuId,
    method: 'get',
  })
}
// 批量半托备注
export function setAdminRemarkOne(params) {
  return request({
    url: '/server/order/setAdminRemarkOne',
    method: 'post',
    data: params
  })
}
// 批量设置不出标
export function setAdminBoxlabelFlag(params) {
  return request({
    url: '/server/order/setAdminBoxlabelFlag',
    method: 'post',
    data: params
  })
}
// 批量设置投递
export function setOrderFinish(params) {
  return request({
    url: '/server/order/setOrderFinish',
    method: 'post',
    data: params
  })
}
// 扫码详情
export function listInside(data) {
  return request({
    url: '/server/order/listInside',
    method: 'get',
    params: data
  })
}
// 扫码打印面单（打印助手第三方用）
export function printByScanNew(data) {
  return request({
    url: '/server/order/printByScanNew',
    method: 'post',
    data: data
  })
}
// 扫码打印面单
export function printByBackend(data) {
  return request({
    url: '/server/order/printByBackend',
    method: 'post',
    data: data
  })
}
// 库存单列表
export function stockOrderList(data) {
  return request({
    url: '/server/stockOrder/list',
    method: 'get',
    params: data
  })
}
// 修改库存
export function stockEditNum(data) {
  return request({
    url: '/server/stockOrder/editNum',
    method: 'post',
    data: data
  })
}
// 库存单校验
export function checkDzSku(data) {
  return request({
    url: '/server/stockOrder/checkDzSku',
    method: 'get',
    params: data
  })
}
// 异步面单进度条
export function getDoTiktokPdfCnt(data) {
  return request({
    url: '/server/order/getDoTiktokPdfCnt',
    method: 'get',
    params: data
  })
}
// 美客多获取面单
export function getMercadoShippingLabelList(data) {
  return request({
    url: '/product/mercadoApi/getMercadoShippingLabelList',
    method: 'post',
    data: data
  })
}
// 修改导入订单的包裹号、运单号
export function editPackageInfo(data) {
  return request({
    url: '/server/order/editPackageInfo',
    method: 'post',
    data: data
  })
}
// 合并包裹
export function combinedPackage(data) {
  return request({
    url: '/server/order/combinedPackage',
    method: 'post',
    data: data
  })
}
// 删除pdf
export function deleteBtPdf(data) {
  return request({
    url: '/server/order/deleteBtPdf',
    method: 'post',
    data: data
  })
}
// 组号数据
export function getOrderBasket(data) {
  return request({
    url: '/server/order/getOrderBasket',
    method: 'get',
    params: data
  })
}
// 大屏数据
export function listBigData(data) {
  return request({
    url: '/server/order/listBigData',
    method: 'get',
    params: data
  })
}
// 触发自动任务
export function zipPicklistPdfCondition(data) {
  return request({
    url: '/server/order/zipPicklistPdfCondition',
    method: 'post',
    data: data
  })
}
// 删除任务
export function delZipCondition(data) {
  return request({
    url: '/server/conditions/delZipCondition',
    method: 'post',
    data: data
  })
}
// 任务列表
export function getConditionsList(data) {
  return request({
    url: '/server/conditions/list',
    method: 'get',
    params: data
  })
}
// 更新任务状态
export function editConditions(data) {
  return request({
    url: '/server/conditions/editConditions',
    method: 'post',
    data: data
  })
}
// // 任务详情（无法区分自动任务还是自动下载，暂时弃用）
// export function getTimingDataFromConditon(data) {
//   return request({
//     url: '/server/order/getTimingDataFromConditon',
//     method: 'get',
//     params: data
//   })
// }
export function listProfitSet(data) {
  return request({
    url: '/server/profit/listProfitSet',
    method: 'get',
    params: data
  })
}
export function getProfitSetInfo(appId) {
  return request({
    url: '/server/profit/getProfitSetInfo/' + appId,
    method: 'get',
  })
}
export function addProfitSet(data) {
  return request({
    url: '/server/profit/addProfitSet',
    method: 'post',
    data: data
  })
}
export function editProfitSet(data) {
  return request({
    url: '/server/profit/editProfitSet',
    method: 'post',
    data: data
  })
}
export function removeProfitSet(data) {
  return request({
    url: '/server/profit/removeProfitSet',
    method: 'post',
    data: data
  })
}
// 邀请记录
export function getInviteList(data) {
  return request({
    url: '/server/invite/list',
    method: 'get',
    params: data
  })
}
// 奖励记录
export function listInviteOrder(data) {
  return request({
    url: '/server/invite/listInviteOrder',
    method: 'get',
    params: data
  })
}

// 上传出货图
export function saveScanPicForSku(data) {
  return request({
    url: '/server/order/saveScanPicForSku',
    method: 'post',
    data: data
  })
}
// shein全托-设置发货仓
export function setSheinWarehouseAddress(data) {
  return request({
    url: "/server/order/setSheinWarehouseAddress",
    method: "post",
    data: data,
  })
}
// 发货统计
export function getOrderBasketSend(data) {
  return request({
    url: "/server/order/getOrderBasketSend",
    method: "get",
    params: data,
  })
}
// 重新发货
export function reSendOrder(data) {
  return request({
    url: "/server/order/reSendOrder",
    method: "post",
    data: data,
  })
}
// 欧洲订单计费
export function eurOrderCreate(params) {
  return request({
    url: "/server/order/eurOrderCreate",
    method: "get",
    params: params,
  })
}
// 美国订单计费
export function usOrderCreate(params) {
  return request({
    url: "/server/order/usOrderCreate",
    method: "get",
    params: params,
  })
}
// 欧洲订单获取面单
export function eurLabelGet(params) {
  return request({
    url: "/server/order/eurLabelGet",
    method: "get",
    params: params,
  })
}
// 美国订单获取面单
export function usLabelGet(params) {
  return request({
    url: "/server/order/usLabelGet",
    method: "get",
    params: params,
  })
}
// 取消欧洲订单
export function eurOrderCancel(params) {
  return request({
    url: "/server/order/eurOrderCancel",
    method: "get",
    params: params,
  })
}
// 取消美国订单
export function usOrderCancel(params) {
  return request({
    url: "/server/order/UsOrderCancel",
    method: "get",
    params: params,
  })
}
// joom获取揽收地址
export function getPickupAddresses(data) {
  return request({
    url: "/product/joom/getPickupAddresses",
    method: "get",
    params: data,
  })
}

// joom获取面单
export function getShippingLabel(data) {
  return request({
    url: "/product/joom/getShippingLabel",
    method: "get",
    params: data,
  })
}

// joom线上发货
export function fulfillOnline(data) {
  return request({
    url: "/product/joom/fulfillOnline",
    method: "post",
    data: data,
  })
}

// joom创建发货单
export function createPickupRequest(data) {
  return request({
    url: "/product/joom/createPickupRequest",
    method: "post",
    data: data,
  })
}

// joom获取物流面单
export function generateBoxLabels(data) {
  return request({
    url: "/product/joom/generateBoxLabels",
    method: "post",
    data: data,
  })
}

// 设置第三方发货
export function sendSkcSet(data) {
  return request({
    url: "/server/sendSkc/set",
    method: "post",
    data: data,
  })
}

// 已设置第三方发货列表
export function sendSkcList(data) {
  return request({
    url: "/server/sendSkc/list",
    method: "get",
    params: data,
  })
}

// 删除第三方发货（变为本系统发货）
export function sendSkcDelete(data) {
  return request({
    url: "/server/sendSkc/delete",
    method: "post",
    data: data,
  })
}

// 生成订单
export function addNewOrder(data) {
  return request({
    url: "/server/order/addNew",
    method: "post",
    data: data,
  })
}

// 生成订单-获取物流
export function getYxShipFee(data) {
  return request({
    url: "/server/order/getYxShipFee",
    method: "post",
    data: data,
  })
}

// 获取指纹配置列表
export function getZwCodeList(data) {
  return request({
    url: "/server/zwCode/list",
    method: "get",
    params: data,
  })
}

// 新增指纹配置
export function addZwCode(data) {
  return request({
    url: "/server/zwCode/add",
    method: "post",
    data: data,
  })
}
// 修改指纹配置
export function editZwCode(data) {
  return request({
    url: "/server/zwCode/edit",
    method: "post",
    data: data,
  })
}
// 删除指纹配置
export function deleteZwCode(data) {
  return request({
    url: "/server/zwCode/delete",
    method: "post",
    data: data,
  })
}
// 推送面单
export function uploadZwWaybill(data) {
  return request({
    url: "/server/order/uploadZwWaybill",
    method: "get",
    params: data,
  })
}
// 指纹产品映射菜单-导入
export function uploadFileCode(data) {
  return request({
    url: "/server/zwCode/uploadFileCode",
    method: "post",
    data: data,
  })
}
// 指纹店铺列表
export function zWshopList(data) {
  return request({
    url: "/server/zWshop/list",
    method: "get",
    params: data,
  })
}
// 编辑指纹店铺
export function editzWshop(data) {
  return request({
    url: "/server/zWshop/edit",
    method: "post",
    data: data,
  })
}
// 添加指纹店铺
export function addzWshop(data) {
  return request({
    url: "/server/zWshop/add",
    method: "post",
    data: data,
  })
}
// 删除指纹店铺
export function removezWshop(data) {
  return request({
    url: "/server/zWshop/remove",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(标准/joom/ozon)
export function previewExcelOrdersOss(data) {
  return request({
    url: "/server/order/previewExcelOrdersOss",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(tk)
export function previewUploadTiktokV1(data) {
  return request({
    url: "/server/order/previewUploadTiktokV1",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(亚马逊)
export function previewUploadAmazonV1(data) {
  return request({
    url: "/server/order/previewUploadAmazonV1",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(速卖通)
export function previewImportSuMaiTongOrders(data) {
  return request({
    url: "/server/order/previewImportSuMaiTongOrders",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(ebay)
export function previewImportEbayOrder(data) {
  return request({
    url: "/server/order/previewImportEbayOrder",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(沃尔玛)
export function previewImportWoErMaOrders(data) {
  return request({
    url: "/server/order/previewImportWoErMaOrders",
    method: "post",
    data: data,
  })
}
// 订单预览-导入(美客多)
export function previewImportMercadoOrders(data) {
  return request({
    url: "/server/order/previewImportMercadoOrders",
    method: "post",
    data: data,
  })
}
// 订单预览-获取预览数据
export function getExcelOrdersPreview(data) {
  return request({
    url: "/server/order/getExcelOrdersPreview",
    method: "get",
    params: data,
  })
}
// 订单预览-确认导入
export function confirmExcelOrdersImport(data) {
  return request({
    url: "/server/order/confirmExcelOrdersImport",
    method: "post",
    data: data,
  })
}
// 订单预览-删除预览
export function cancelExcelOrdersPreview(data) {
  return request({
    url: "/server/order/cancelExcelOrdersPreview",
    method: "post",
    data: data,
  })
}
// 推送日志
export function orderSyncLog(data) {
  return request({
    url: "/server/orderSyncLog/list",
    method: "get",
    params: data,
  })
}
// joom分类
export function getJoomProductCategories(params) {
  return request({
    url: "/product/joom/getJoomProductCategories",
    method: "get",
    params,
  })
}
// joom商品属性
export function getJoomCategoryRequirements(params) {
  return request({
    url: "/product/joom/getJoomCategoryRequirements",
    method: "get",
    params,
  })
}
// joom属性选项值
export function getJoomCategoryAttributeValues(params) {
  return request({
    url: "/product/joom/getJoomCategoryAttributeValues",
    method: "get",
    params,
  })
}
// joom颜色
export function getJoomProductColors(params) {
  return request({
    url: "/product/joom/getJoomProductColors",
    method: "get",
    params,
  })
}
// 撤销订单
export function withdrawOrder(data) {
  return request({
    url: "/server/order/withdrawOrder",
    method: "post",
    data: data,
  })
}